import axios from "axios";
class ApiFaq {
    static async GetFaq(session_uuid) {
        try {
            const result = await axios.get("/api/admin/get-faq", {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.data;
        }
        catch (e) {
            throw new Error("Error get faq");
        }
    }
    static async GetFaqByUUID(session_uuid, uuid) {
        try {
            const result = await axios.post("/api/admin/get-faq-by", {
                uuid: uuid
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.data;
        }
        catch (e) {
            return undefined;
        }
    }
    static async CreateFaqQuestion(session_uuid, item) {
        try {
            const result = await axios.post("/api/admin/create-faq", {
                answer_eng: item.answer_eng,
                answer_du: item.answer_du,
                answer_fr: item.answer_fr,
                question: item.question,
                question_du: item.question_du,
                question_fr: item.question_fr,
                priority: item.priority,
                publish: item.publish,
                category: item.category
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.response;
        }
        catch (e) {
            console.error(e);
            if ("response" in e && "data" in e.response && "response" in e.response.data) {
                return e.response.data.response;
            }
        }
        return undefined;
    }
    static async DeleteFaqQuestion(session_uuid, uuid) {
        try {
            const result = await axios.post("/api/admin/delete-faq", { uuid }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.response;
        }
        catch (e) {
            return undefined;
        }
    }
    static async UpdateFaqPublish(session_uuid, item) {
        try {
            const result = await axios.post("/api/admin/change-faq-publish", {
                uuid: item.uuid,
                publish: item.publish
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.response;
        }
        catch (e) {
            throw new Error("Error");
        }
    }
    static async UpdateFaqInfo(session_uuid, item) {
        try {
            const result = await axios.post("/api/admin/change-faq", {
                uuid: item.uuid,
                answer_eng: item.answer_eng,
                answer_du: item.answer_du,
                answer_fr: item.answer_fr,
                question: item.question,
                question_du: item.question_du,
                question_fr: item.question_fr,
                priority: item.priority,
                publish: item.publish,
                category: item.category
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.response;
        }
        catch (e) {
            throw new Error("Error");
        }
    }
    static async GetFaqCategories(session_uuid) {
        try {
            const result = await axios.get("/api/admin/get-faq-categories", {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.data;
        }
        catch (e) {
            throw new Error("Error get faq category");
        }
    }
    static async GetFaqCategoryByUUID(session_uuid, uuid) {
        try {
            const result = await axios.post("/api/admin/get-faq-category-by", {
                uuid: uuid
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.data;
        }
        catch (e) {
            return undefined;
        }
    }
    static async CreateFaqCategory(session_uuid, item) {
        try {
            const result = await axios.post("/api/admin/create-faq-category", {
                name: item.name,
                name_du: item.name_du,
                name_fr: item.name_fr,
                priority: item.priority,
                publish: item.publish
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.response;
        }
        catch (e) {
            console.error(e);
            if ("response" in e && "data" in e.response && "response" in e.response.data) {
                return e.response.data.response;
            }
        }
        return undefined;
    }
    static async DeleteFaqCategory(session_uuid, uuid) {
        try {
            const result = await axios.post("/api/admin/delete-faq-category", {
                uuid: uuid
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.response;
        }
        catch (e) {
            return undefined;
        }
    }
    static async UpdateFaqCategoryPublish(session_uuid, item) {
        try {
            const result = await axios.post("/api/admin/change-faq-category-publish", {
                uuid: item.uuid,
                publish: item.publish
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.response;
        }
        catch (e) {
            throw new Error("Error");
        }
    }
    static async UpdateFaqCategoryInfo(session_uuid, item) {
        try {
            const result = await axios.post("/api/admin/change-faq-category-info", {
                uuid: item.uuid,
                name: item.name,
                name_du: item.name_du,
                name_fr: item.name_fr,
                priority: item.priority,
                publish: item.publish
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid
                }
            });
            return result.data.response;
        }
        catch (e) {
            throw new Error("Error");
        }
    }
}
export default ApiFaq;
